import React from "react";
import { useRecoilState } from "recoil";
import { isOpenEmojiState, textState } from "../../../atoms/atom";
import emoji from "../data/emoji.json";

interface IProps {
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

function Emoji(props: IProps) {
  let { setValue } = props;
  const [text, setText] = useRecoilState(textState);
  const [isOpenEmoji, setIsOpenEmoji] = useRecoilState(isOpenEmojiState);

  const selectEmoji = (i: number) => {
    setText(text + `<img src='${emoji.emoticon[i].image_url}' />`);
    setValue(text + `<img src='${emoji.emoticon[i].image_url}' />`);
    setIsOpenEmoji(false);
  };

  return isOpenEmoji ? (
    <ul className="emoji-list">
      {emoji.emoticon.map((i, idx) => (
        <li className="emojis" key={i.title} onClick={(e) => selectEmoji(idx)}>
          <img src={i.image_url} alt={i.title} />
        </li>
      ))}
    </ul>
  ) : null;
}

export default Emoji;
